/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY2xtdGxrL3NoYXJlZC9jb21wb25lbnQvbWVudS1iYXIvbWVudS1iYXIuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2plbmtpbnNfaG9tZS93b3Jrc3BhY2UvQ0xBSU1TX1BJUEVMSU5FL0NMTVRMS19VSV9BUFBfUElQRUxJTkUvc3JjL2FwcC9jbG10bGsvc2hhcmVkL2NvbXBvbmVudC9tZW51LWJhci9tZW51LWJhci5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/clmtlk/shared/component/menu-bar/menu-bar.component.scss.shim.ngstyle.ts